export default class Settings {
  constructor ({ restrictions = {} } = {}) {
    this.restrictions = restrictions
  }
}
